import { combineReducers } from "redux";

import listSettingReportReducer from './listSetting'

const settingReducer = combineReducers({
    listSettingReportReducer
})

export default settingReducer;